module.exports = __webpack_public_path__ + "media/images/country_flags/cg-e0f5b3ab2885f96ddb1d17d2ac6daa8b.png";